import { render, staticRenderFns } from "./FundsBuy.vue?vue&type=template&id=4b1b66a2"
import script from "./FundsBuy.vue?vue&type=script&lang=js"
export * from "./FundsBuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports